import { render, staticRenderFns } from "./dictamen.vue?vue&type=template&id=0867dd88&scoped=true&"
import script from "./dictamen.component.ts?vue&type=script&lang=ts&"
export * from "./dictamen.component.ts?vue&type=script&lang=ts&"
import style0 from "./dictamen.vue?vue&type=style&index=0&id=0867dd88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867dd88",
  null
  
)

export default component.exports